import './Card.css';

function HanziLink(props){
  if (props.mbp) {    
    return <a href={props.mbp} target="_blank">{props.hanzi}</a>;
  } else {    
    return props.hanzi;
  }
}

const Card = ({hanzi, heisig, pinyin, initial, final, mbp, course, level}) => {
  let dc = 'https://www.dong-chinese.com/dictionary/search/' + hanzi;
  let hsk = 'https://hsk.academy/en/characters/' + hanzi;
  let bing = 'https://www.zerotohero.ca/en/zh/phrase/search/' + hanzi;

  return (
    <div className="CardWrapper">
      <div className="ColHanzi">
            <HanziLink mbp={mbp} hanzi={hanzi} />
      </div>
      <div className="ColDetail">
          <div className="BookTitle">{pinyin}</div>
          <div className="Level">Level: {level}</div>
                    <div className="Heisig"></div>
        <a className="Link" href={dc} target="_blank">
          Dong</a> |&nbsp;  
         <a className="Link" href={hsk} target="_blank">
          HSK
        </a> |&nbsp;
         <a className="Link" href={bing} target="_blank">
          Z2H
        </a><br />
        
      </div>
    </div>
  );
};

export default Card;